"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _input = require("baseui/input");

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _react = _interopRequireWildcard(require("react"));

var _rifm = require("rifm");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

const MaskedInput = props => {
  const [internalValue, setInternalValue] = (0, _react.useState)('');
  const {
    value,
    onChange,
    format: propsFormat,
    accept,
    ...inputProps
  } = props;
  const rifmValue = (0, _isNil.default)(value) ? internalValue : value;

  function format(value) {
    if (!propsFormat) return value;
    if ((0, _isNil.default)(value)) return propsFormat('', internalValue);
    return propsFormat(value, internalValue);
  }

  function rifmOnChange(value) {
    setInternalValue(value);
    onChange === null || onChange === void 0 ? void 0 : onChange(value);
  } // by default, Rifm only accepts digits. We rely on format to do the filtering, and
  // set "accept" to accept all chars


  return /*#__PURE__*/_react.default.createElement(_rifm.Rifm, {
    value: rifmValue.toString(),
    accept: accept,
    format: format,
    onChange: rifmOnChange
  }, rifmProps => {
    return /*#__PURE__*/_react.default.createElement(_input.Input, _extends({}, rifmProps, inputProps));
  });
};

var _default = MaskedInput;
exports.default = _default;